import React, { ReactNode } from 'react';
import styles from './assets/credit-screen.module.scss';
import classNames from 'classnames';
import CreditsGrid from './components/CreditsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import { ICredit } from 'src/types/credit';
import RoleLayout from '../../../../../../components/layout/RoleLayout';

export interface StateProps {
    data: Paginated<ICredit>;
    payments: SelectObject[];
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
    getPayments: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class CreditsList extends React.Component<Props> {
    componentDidMount() {
        this.props.getPayments({
            page: 1,

            itemsPerPage: 9000,
        });
    }
    public render(): ReactNode {
        const { data, getData, payments } = this.props;

        return (
            <RoleLayout>
                <div className={`pageHeading`}>
                    <h2 className={`pageHeadingTitle`}>CREDITS {data.totalCount ? '(' + data.totalCount + ')' : ''}</h2>
                </div>
                <div className={classNames(styles.list)}>
                    <CreditsGrid payments={payments} data={data} getData={getData} />
                </div>
            </RoleLayout>
        );
    }
}

export default CreditsList;
